import project1 from "../assets/images/thumb-engaz.png";
import project2 from "../assets/images/thumb-healthy.png";
import project3 from "../assets/images/ai-hero-1.png";

const store = [
    {
        id: 1,
        image: project1,
        title: "Engaz HTML Template",
        description: "Delivery & Shipping HTML Website Template",
        price: "$35",
        link: "https://whop.com/alsaleh-templates/html-website-template/?utm_source=store_page&funnelId=store_24e94524-b170-48ef-8701-b2a48a324aa5"
    },
    {
        id: 2,
        image: project2,
        title: "Healthy HTML Template",
        description: "Healthy Grocery Store HTML Website Template",
        price: "$38",
        link: "https://whop.com/alsaleh-templates/html-website-template-dd/?utm_source=store_page&funnelId=store_24e94524-b170-48ef-8701-b2a48a324aa5"
    },
    {
        id: 3,
        image: project3,
        title: "AI Hero Section – HTML & CSS Template",
        description: "A modern, responsive Hero Section designed for AI / SaaS / Tech products.",
        price: "$8",
        link: "https://whop.com/alsaleh-templates/html-website-template-dd/?utm_source=store_page&funnelId=store_24e94524-b170-48ef-8701-b2a48a324aa5"
    },

]

export default store;